
//---POWER SUPPLY LEAD------------------------------------------:
export const createPowerSupplyLead = data => {
  //data = {id, description, type}
  return { type: "CREATE_POWER_SUPPLY_LEAD", payload: data };
};
//---POWER SUPPLY LEAD------------------------------------------:
export const setPowerSupplyLeadPostive = data => {
  //data = {current}
  return { type: "SET_POSITIVE_POWER_SUPPLY_LEAD_POSITION", payload: data };
};

export const setPowerSupplyLeadNegative = data => {
  //data = {current}
  return { type: "SET_NEGATIVE_POWER_SUPPLY_LEAD_POSITION", payload: data };
};

export const setPositiveLeadConnection = data => {
  //data = {current}
  return { type: "SET_POSITIVE_POWER_SUPPLY_LEAD_CONNECTION", payload: data };
};

export const setNegativeLeadConnection = data => {
  //data = {current}
  return { type: "SET_NEGATIVE_POWER_SUPPLY_LEAD_CONNECTION", payload: data };
};

export const setPowerSupplyLeadHeld = (data) => {
  //data = {id, inScene}
  return { type: "SET_POWER_SUPPLY_LEAD_HELD", payload: data}
}

//Set whether the flask controls are displayed or not
export const setPowerSupplyLeadControlVisibility = (data) => {
  //data = {id, animatingOut}
  return { type: "SET_POWER_SUPPLY_LEAD_CONTROLS_VISIBLE", payload: data}
}
